export default __webpack_public_path__ + "static/favicon-357977cd65b7e580e7608c32c305710f.png";